<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-left">
            <ol class="breadcrumb">
              <li
                class="breadcrumb-item"
                :key="index"
                v-for="(routeObject, index) in routeRecords"
                @click="dashboard(routeObject)"
              >
                <span class="breadcrumb-active" v-if="isLast(index)">
                  {{ getName(routeObject) }}
                </span>
                <router-link :to="{ path: routeObject.path }" v-else>
                  {{ getName(routeObject) }}
                  <span class="breadcrumb-icon" v-if="!isLast(index)">
                    <feather-icon
                      icon="ChevronsRightIcon"
                      svgClasses="w-4 h-3"
                    />
                  </span>
                </router-link>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vx-breadcrumb",
  props: {
    list: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {
    routeRecords() {
      return this.list.filter(
        (route) => route.name || (route.meta && route.meta.label)
      );
    },
  },
  methods: {
    getName(item) {
      return item.meta && item.meta.label ? item.meta.label : item.name || "";
    },
    isLast(index) {
      return index === this.list.length - 1;
    },
    dashboard(object) {
      if (object.name === "Dashboard") {
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style>
.page-title-box .page-title {
  font-size: 18px;
  margin: 0;
  line-height: 85px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: inherit;
}

.page-title-box .page-title-right {
  float: right;
  margin-top: 25px;
}

.page-title-box .breadcrumb {
  padding-top: 8px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
}

.breadcrumb-item:last-child {
  margin-right: 0;
}

.breadcrumb-icon {
  margin-right: 0.25rem;
}

.breadcrumb-active {
  font-weight: bold;
}
</style>
